import { render, staticRenderFns } from "./payWay.vue?vue&type=template&id=207cb22a&scoped=true"
import script from "./payWay.vue?vue&type=script&lang=js"
export * from "./payWay.vue?vue&type=script&lang=js"
import style0 from "./payWay.vue?vue&type=style&index=0&id=207cb22a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207cb22a",
  null
  
)

export default component.exports